import { useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { AppContext, AppContextProps } from "components/AppContextProvider";

export const useAppContext = () => useContext<AppContextProps>(AppContext);

export const useNotification = (): Pick<
  AppContextProps,
  "notification" | "toggleNotification"
> => {
  const { notification, toggleNotification } = useContext(AppContext);

  return { notification, toggleNotification };
};

export const useQueryParams = (): URLSearchParams => {
  const { search } = useLocation();

  return useMemo<URLSearchParams>(() => new URLSearchParams(search), [search]);
};
